<template>
  <div class="sign" v-pageBuried data-page-buried="BG_XINRENHUODONG_ZHUYE">
    <div class="container">
      <div class="wrapper">
        <div class="back" @click="bindBack"
          ><span class="iconfont icon-fanhui"></span
        ></div>
        <div class="btn-list">
          <div
            class="share-btn"
            @click="bindShare"
            v-clickBuried
            data-click-buried="CLINK_XINRENHUODONG_FENXIANG"
          >
            <span class="iconfont icon-fenxiang1"></span>
          </div>
          <div class="btn-item" @click="bindShowRule"><span>规则</span></div>
          <div class="btn-item" @click="bindToPrizePage"><span>奖品</span></div>
        </div>
        <div class="top">
          <!--奖品滚动 -->
          <!-- <div class="prize-user-container">
                        <div class="prize-user-overflow">
                            <div class="prize-user-content">
                                <van-notice-bar :scrollable="false" background="transparent" speed="30">
                                    <van-swipe vertical class="prize-user-swipe" :autoplay="3000" :show-indicators="false">
                                        <van-swipe-item v-for="(item, index) in prizeNotice" :key="index">
                                            <div class="prize-user-item">{{ item }}</div>
                                        </van-swipe-item>
                                    </van-swipe>
                                </van-notice-bar>
                            </div>
                        </div>
                    </div> -->
          <NoticeComponent
            style="height: 40px"
            class="notice-component"
            :data="prizeNotice"
          />
          <!--  -->
          <div class="integral-content" v-if="integralInfo">
            <div class="mask">
              <div class="integral-dot-filter"></div>
            </div>
            <div class="integral-item integral-item-first">
              <img
                class="integral-icon"
                src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/526935ebb62d34ed1258b8047048ec3c.webp"
                alt=""
              />
              <span class="integral-text">我的积分</span>
            </div>
            <div
              class="integral-item"
              @click="bindIntegralExchange"
              v-clickBuried
              data-click-buried="CLICK_XRQD_MORE_1"
            >
              <span class="integral-num"
                ><span>{{ integralInfo.wmIntegral }}</span>
                <img
                  src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/abdf2c645037387339127ef1452c72d4.webp"
                  class="integral-flag"
                  alt=""
                />
              </span>
              <span class="iconfont icon-you"></span>
            </div>
          </div>
          <SignContent
            ref="sign"
            v-if="signInfo"
            @sign="bindSign"
            :data="signInfo"
          />
          <TaskContent
            v-if="taskData"
            :data="taskData"
            @confirm="completeTask"
          />
        </div>
        <integralExchange v-if="goodsData" :data="goodsData" />
      </div>
    </div>
    <!-- 弹框 -->
    <van-overlay :show="showToast" @click="showToast = false" z-index="2000">
      <div
        class="toast-wrapper animate__animated animate__bounceIn"
        v-if="signInfo"
      >
        <SignSuccessToast
          v-if="toastType == 1"
          :data="signInfo"
          @close="bindCloseToast"
        />
        <NotSignToast
          v-if="toastType == 2"
          :data="signInfo"
          @confirm="bindConfirm"
          @cancel="bindCancel"
        />
        <RuleToast v-if="toastType == 3" />
      </div>
    </van-overlay>
    <!--  -->
    <!-- 分享组件 -->
    <ShareComponent
      v-model="showShare"
      :options="iconList"
      @cancel="bindShareCancel"
      @select="bindShareSelect"
    />
  </div>
</template>
<script>
import { eventObj } from '@/components/app/share/share-method.js'
import SignContent from './components/sign.vue'
import TaskContent from './components/task.vue'
import integralExchange from './components/integral-exchange.vue'
import SignSuccessToast from './components/sign-success-toast.vue'
import NotSignToast from './components/not-sign-toast.vue'
import ShareComponent from '@/components/app/share/share.vue'
import RuleToast from './components/rule-toast.vue'
import NoticeComponent from './components/notice-component.vue'
export default {
  name: 'user-sign-index',
  components: {
    SignContent,
    TaskContent,
    integralExchange,
    SignSuccessToast,
    NotSignToast,
    ShareComponent,
    RuleToast,
    NoticeComponent
  },
  data() {
    return {
      toastType: 1,
      activity_id: 1,
      loaded: true,
      showToast: false,
      signInfo: null,
      integralInfo: null,
      taskData: null,
      goodsData: null,
      prizeNotice: [],
      showShare: false,
      qrcodeUrl: 'https://member3.gymcity.com.cn/#/app-download',
      shareOptions: {
        title: '营养师甄选减脂好物100%免费拿！',
        desc: '新人连续签到限时活动，超值羊毛，仅限一波～',
        thumbnail:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-share-image'
      },
      iconList: [
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon2',
          name: '微信好友',
          id: 1
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon3',
          name: '朋友圈',
          id: 2
        }
      ]
    }
  },
  created() {
    this.getParams()
    this.addEventPage()
    this.getSignInfo()
    this.getIntegralInfo()
    this.getTaskInfo()
    this.getGoods()
    this.getPrizeNotice()
  },
  methods: {
    getParams() {
      if (this.$route.query.sign_activity_id) {
        this.activity_id = this.$route.query.sign_activity_id
      }
    },
    addEventPage() {
      window.onPageResumed = () => {
        this.getIntegralInfo()
        this.getTaskInfo()
      }
    },
    bindShare() {
      this.showShare = true
    },
    bindShareCancel() {
      this.showShare = false
    },
    bindShareSelect(options) {
      this.showShare = false
      let shareOptions = Object.assign({}, this.shareOptions)
      switch (options.id) {
        // 分享链接到微信好友
        case 1:
          shareOptions.url = this.qrcodeUrl
          eventObj.shareLinkToWxFriend(shareOptions)
          break
        // 分享链接到微信朋友圈
        case 2:
          shareOptions.url = this.qrcodeUrl
          eventObj.shareLinkToWxCircle(shareOptions)
          break
      }
    },
    bindShowRule() {
      this.$router.push('/user-sign/rule')
    },
    bindBack() {
      if (this.signInfo && !this.signInfo.is_sign) {
        this.toastType = 2
        this.showToast = true
      } else {
        this.$http.appBack()
      }
    },
    bindCloseToast() {
      this.showToast = false
      setTimeout(() => {
        let el = document.getElementById('task-container')
        if (el) {
          el.scrollIntoView(true, { behavior: 'smooth' })
        }
      }, 300)
    },
    bindConfirm() {
      this.showToast = false
      this.bindSign()
    },
    bindCancel() {
      this.showToast = false
      setTimeout(() => {
        this.$http.appBack()
      }, 500)
    },
    //去积分兑换奖品
    bindIntegralExchange() {
      this.$betterwe.jumpRoute(
        '/wmOtherPage?fromType=11&url=https://t.weimob.com/DT_MYRf'
      )
    },
    bindSign() {
      if (this.signInfo.is_sign) {
        return
      }
      this.$http
        .postAppWithAppInfo('api/v1/SignActivity/signIn', {
          activity_id: this.activity_id
        })
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.signInfo.continuous_day = +this.signInfo.continuous_day + 1
            this.signInfo.is_sign = 1
            this.toastType = 1
            this.showToast = true
            this.getIntegralInfo()
            this.$refs.sign?.init()
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
    },
    bindToPrizePage() {
      this.$router.push('/user-sign/prize-list')
    },
    signApi() {
      this.$http
        .postAppWithAppInfo('api/v1/SignActivity/signIn', {
          activity_id: this.activity_id
        })
        .then((res) => {
          res = res.data
        })
        .catch(() => {})
    },
    async getData() {
      let promise1 = this.$http.getAppWithAppInfo(
        'api/v1/SignActivity/getSignTaskList',
        { activity_id: this.activity_id }
      )
      let promise2 = this.$http.getAppWithAppInfo(
        'api/v1/SignActivity/getSignActivityInfo',
        { activity_id: this.activity_id }
      )
      let promise3 = this.$http.getAppWithAppInfo(
        'api/v1/SignActivity/getUserActivityPlan',
        { activity_id: this.activity_id }
      )
      let res = await Promise.all([promise1, promise2, promise3]).catch(
        () => {}
      )
    },
    /* 获取签到信息 */
    getSignInfo() {
      this.$http
        .getAppWithAppInfo('api/v1/SignActivity/getSignTaskList', {
          activity_id: this.activity_id
        })
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            /*   res.data.continuous_day = 7;
            res.data.is_sign = 0; */
            this.signInfo = res.data
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
    },
    getIntegralInfo() {
      this.$http
        .getAppWithAppInfo('api/v1/SignActivity/getSignActivityInfo', {
          activity_id: this.activity_id
        })
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.integralInfo = res.data
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
    },
    getTaskInfo() {
      this.$http
        .getAppWithAppInfo('api/v1/SignActivity/getUserActivityPlan', {
          activity_id: this.activity_id
        })
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.taskData = res.data
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
    },
    getGoods() {
      this.$http
        .getAppWithAppInfo('api/v1/IntegralGoods/index', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.goodsData = res.data
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
    },
    getPrizeNotice() {
      this.$http
        .getAppWithAppInfo('api/v1/SignActivity/getRewardAnnouncement', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.prizeNotice = res.data || []
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
    },
    completeTask(item) {
      let params = {
        plan_id: item.plan_id
      }
      this.$http
        .postAppWithAppInfo('api/v1/SignActivity/completePlan', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            item.isComplete = 1
            this.getIntegralInfo()
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
    }
  }
}
</script>
<style lang="scss" scoped>
.sign {
  .container {
    overflow: hidden;
    min-height: 100vh;
    background-color: #ffeacf;
    background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/5da4a21327fa66d89ad32fc9b3be1570.png');
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center top;

    .back {
      z-index: 999;
      position: fixed;
      left: 14px;
      top: 53px;
      width: 30px;
      height: 30px;
      background: rgba(0, 0, 0, 0.16);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;

      .iconfont {
        color: #fff;
        font-size: 18px;
      }
    }

    .btn-list {
      z-index: 999;
      position: fixed;
      right: 0px;
      top: 53px;
      display: flex;
      flex-direction: column;

      .share-btn {
        margin-bottom: 16px;
        width: 30px;
        height: 30px;
        background: rgba(0, 0, 0, 0.16);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 11px;
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        color: #ffffff;
        line-height: 20px;

        .iconfont {
          font-size: 14px;
          font-weight: 700;
        }
      }
      .btn-item {
        padding-left: 2px;
        box-sizing: border-box;
        width: 44px;
        height: 20px;
        background: rgba(0, 0, 0, 0.3);
        border-radius: 100px 0px 0px 100px;
        backdrop-filter: blur(6px);
        font-weight: bold;
        font-size: 11px;
        color: #ffffff;
        line-height: 20px;
        text-align: center;
        margin-bottom: 8px;
      }
    }

    .wrapper {
      margin-top: 274px;

      .top {
        position: relative;
        padding: 0px 14px;
        margin-bottom: 27px;

        .notice-component {
          position: absolute;
          position: absolute;
          left: 0px;
          top: -46px;
          width: 100%;
          padding: 0px 14px;
          box-sizing: border-box;
          height: 40px;
          z-index: 999;
          overflow: hidden;
        }

        .prize-user-container {
          width: 100%;
          height: 40px;
          position: absolute;
          left: 0px;
          top: -46px;

          .prize-user-overflow {
            height: 100%;
            overflow: hidden;
          }

          .prize-user-content {
            height: 26px;

            ::v-deep .van-notice-bar {
              height: 100%;
            }

            ::v-deep .van-notice-bar__wrap {
              overflow: visible;
            }

            ::v-deep .van-ellipsis {
              overflow: visible;
            }

            ::v-deep .van-swipe {
              overflow: visible;
            }
          }
        }

        .prize-user-swipe {
          height: 26px;

          .prize-user-item {
            display: inline-block;
            padding: 0px 7px;
            white-space: nowrap;
            height: 20px;
            background: rgba(0, 0, 0, 0.3);
            border-radius: 10px;
            backdrop-filter: blur(6px);
            font-size: 10px;
            font-family: PingFangSC, PingFang SC;
            font-weight: bold;
            color: #ffffff;
            line-height: 20px;
          }
        }

        .integral-content {
          height: 50px;
          display: flex;
          align-items: center;
          background: rgba(255, 255, 255, 0.93);
          box-shadow: 0px 5px 9px 0px rgba(75, 195, 156, 0.47);
          border-radius: 26px;
          border: 2px solid #ffffff;
          backdrop-filter: blur(9px);
          margin-bottom: 17px;
          position: relative;

          .mask {
            border-radius: 25px;
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            overflow: hidden;
          }

          .integral-dot-filter {
            position: absolute;
            width: 125px;
            height: 125px;
            background-color: #fff9cd;
            border-radius: 50%;
            filter: blur(36px);
            left: -46px;
            top: -90px;
          }

          .integral-item {
            position: relative;
            flex: 1;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            .integral-flag {
              position: absolute;
              left: 50%;
              top: 0;
              transform: translate(-50%, -90%);
              width: 104px;
              height: 22px;
              object-fit: contain;
            }

            .integral-icon {
              width: 20px;
              height: 20px;
              margin-right: 6px;
            }

            .integral-text {
              font-size: 18px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
              color: rgba(0, 0, 0, 0.8);
              line-height: 25px;
            }

            .integral-num {
              position: relative;
              font-size: 26px;
              font-family: DIN, DIN;
              font-weight: bold;
              color: #ff6464;
              line-height: 31px;
              margin-right: 4px;
            }

            .iconfont {
              font-size: 18px;
              font-weight: 600;
              color: rgba(0, 0, 0, 0.3);
            }
          }

          .integral-item-first::after {
            content: '';
            position: absolute;
            top: 50%;
            right: 0%;
            transform: translate(-50%, -50%);
            width: 1px;
            height: 16px;
            background-color: rgba(0, 0, 0, 0.12);
          }
        }

        .top-item {
          margin-bottom: 20px;
        }
      }
    }
  }
}

.toast-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
